// Platform identity only. Never merge into tenant/company, issuer or sender settings.
export const PLATFORM_BRAND = Object.freeze({
  name: "VISION ELANTI",
  tagline: "The Vision Behind Intelligent Logistics",
  pronunciation: "VI-ZJUN E-LAN-TIE",
  owner: "5999Cargo Group",
  firstOperationalTenant: "5999Cargo",
  storyNotice: "Creatief merkverhaal, geen historische etymologie.",
  meaning: Object.freeze([
    Object.freeze({ key: "VISION", value: "Visibility. Innovation. Strategic Intelligence." }),
    Object.freeze({ key: "EL", value: "Enterprise Logistics." }),
    Object.freeze({ key: "AN", value: "Automation Network." }),
    Object.freeze({ key: "TI", value: "Technology & Intelligence." }),
  ]),
  assets: Object.freeze({
    original: "/brand/vision-elanti/original.png",
    light: "/brand/vision-elanti/logo-light.png",
    dark: "/brand/vision-elanti/logo-dark-surface.png",
    dashboard: "/brand/vision-elanti/logo-light.png",
    futurePlatformLogin: "/brand/vision-elanti/logo-light.png",
    app192: "/brand/vision-elanti/app-192.png",
    app512: "/brand/vision-elanti/app-512.png",
    compactIcon: null,
    favicon: null,
  }),
});